import { ReactSVG } from "react-svg";
import styled from "styled-components";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownDivider,
} from "styled-dropdown-component";

export const ImageIcon = styled.img`
  width: 15px;
  height: 13px;
  padding-right: 2px;
`;

export const DropdownCustom = styled(Dropdown)``;

export const DropdownTitleCustom = styled(DropdownItem)`
  font-size: 13px;
  cursor: default;
`;

export const DropdownItemCustom = styled(DropdownItem)`
  font-size: 13px;
  cursor: pointer;
`;

export const DropdownMenuCustom = styled(DropdownMenu)`
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
  position: absolute;
  top: 0px;
  left: -135px;
`;
// left: -145px;

export const DropdownDividerCustom = styled(DropdownDivider)``;

export const SvgIcon = styled(ReactSVG)`
  fill: #00a2e0 !important;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;
